/* eslint-disable react/prop-types */

export const ATTR_NAME_MAPPING = {
  chipset: 'Chipset',
  ssd_gen: 'SSD Generation',
  brand: 'Brand',
  chassis_fans_brand: 'Chassis Fans Brand',
  psu_size: 'PSU Size',
  hdd_physical_size: 'HDD Physical Size',
  pcie_slots: 'PCIe Slots',
};

export const ATTR_VALUE_MAPPING = {
  amd: 'AMD',
  intel: 'Intel',
  4: '4th',
  lga1200: 'Intel',
  LGA1200: 'Intel',
  lga1151: 'Intel',
  lga2066: 'Intel',
  am4: 'AMD',
  tr4: 'Threadripper',
  swrx8: 'Threadripper Pro',
};

export const OPERATOR_MAPPING = {
  is: 'equal to',
  min: 'at least',
  max: 'up to',
  in: 'one of',
};

export const TEMPLATES = [
  {
    attrName: 'brand',
    operator: 'is',
    isAggr: false,
    render: ({ from, to, attrValue }) => (
      <>
        Your {from} and {to} need to match. Your {from} is currently {attrValue}
        .
      </>
    ),
  },
  {
    attrName: 'case_large',
    operator: 'min',
    isAggr: false,
    render: ({ from }) => <>To choose this {from} you need a larger chassis.</>,
  },
  {
    attrName: 'case_lighting_included',
    operator: 'is',
    isAggr: false,
    render: ({ from }) => (
      <>Your {from} comes with in-built lighting. No need to double up.</>
    ),
  },
  {
    attrName: 'chassis_fans_brand',
    operator: 'is',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        Your {from} doesn&apos;t match the brand of your {to}. This means you
        will have extra control software, making it harder to keep it looking
        good.
      </>
    ),
  },
  {
    attrName: 'chassis_fans_size',
    operator: 'min',
    isAggr: false,
    render: ({ from, to, attrValue }) => (
      <>
        This {from} requires {attrValue}mm {to}.
      </>
    ),
  },
  {
    attrName: 'chipset',
    operator: 'is',
    isAggr: false,
    render: ({ from, to, attrValue }) => {
      if (attrValue == 'lga1700') {
        return (
          <>
            Your {from} requires an INTEL {to}.
          </>
        );
      } else if (attrValue == 'AMD' || attrValue == 'am5') {
        return (
          <>
            Your {from} requires an{' '}
            {(attrValue == 'AMD' && ' AMD 5000 ') ||
              (attrValue == 'am5' && ' AMD 7000 ')}{' '}
            series {to}.
          </>
        );
      } else if (attrValue == 'lga4677') {
        return (
          <>
            Your {from} requires the {to} to be Intel Xeon.
          </>
        );
      } else {
        return (
          <>
            Your {from} requires the {to} to be {attrValue}.
          </>
        );
      }
    },
  },
  {
    attrName: 'chipset',
    operator: 'in',
    isAggr: false,
    render: ({ from }) => <>Remember to update your {from}.</>,
  },
  {
    attrName: 'cpu_cooling_capacity',
    operator: 'min',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        The {from} chosen can run hot. Keep it cool by selecting a better {to}.
      </>
    ),
  },
  {
    attrName: 'cpu_cooling_depth',
    operator: 'max',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        To select this {to} you need a bigger {from}.
      </>
    ),
  },
  {
    attrName: 'cpu_cooling_size',
    operator: 'max',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        To select this {to} you need a bigger {from}.
      </>
    ),
  },
  {
    attrName: 'gpu_size',
    operator: 'max',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        To select this {to} you need a bigger {from}.
      </>
    ),
  },
  {
    attrName: 'hdd_physical_size',
    operator: 'is',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        The {from} dimensions you have selected are too large for the {to}{' '}
        selected.
      </>
    ),
  },
  {
    attrName: 'motherboard_quality',
    operator: 'min',
    isAggr: false,
    render: ({ to }) => (
      <>
        The {to} is the heart of the system and with your current selection you
        run the risk of bottlenecking. Good idea to select a higher spec {to}.
      </>
    ),
  },
  {
    attrName: 'num_phys_chassis_fans',
    operator: 'max',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        Your {from} can&apos;t handle this many {to}.
      </>
    ),
  },
  {
    attrName: 'num_chassis_fans',
    operator: 'max',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        This many {to} needs a bigger {from}.
      </>
    ),
  },
  {
    attrName: 'num_chassis_fans',
    operator: 'min',
    isAggr: false,
    render: ({ to }) => (
      <>
        You&apos;ve selected some powerful components! Keep them cool by adding
        more {to}.
      </>
    ),
  },
  {
    attrName: 'num_gpus',
    operator: 'max',
    isAggr: true,
    render: ({ from }) => (
      <>Your {from} is too small to fit this many GPU&apos;s.</>
    ),
  },
  {
    attrName: 'num_hdds',
    operator: 'max',
    isAggr: true,
    render: ({ to }) => (
      <>
        You can&apos;t fit this many Hard Drives, think about increasing the
        capacity of the existing hard drives or selecting a bigger {to}.
      </>
    ),
  },
  {
    attrName: 'num_ram_slots',
    operator: 'max',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        Your {from} selection doesn&apos;t have enough RAM slots for your {to}{' '}
        selection.
      </>
    ),
  },
  {
    attrName: 'num_ram_slots',
    operator: 'min',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        Your {from} selection has more slots than what the {to} selection
        supports.
      </>
    ),
  },
  {
    attrName: 'num_ssds',
    operator: 'max',
    isAggr: true,
    render: ({ from }) => <>You need a {from} with more M.2 SSD slots.</>,
  },
  {
    attrName: 'ram_speed',
    operator: 'max',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        To get the most out this {to}, you will need a higher spec {from}
      </>
    ),
  },
  {
    attrName: 'ram_speed',
    operator: 'min',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        {from} requires the {to} to be DDR5
      </>
    ),
  },
  {
    attrName: 'ssd_gen',
    operator: 'is',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        You will need a higher spec {from} to run a {to} speed that fast.
      </>
    ),
  },
  {
    attrName: 'thermal_compound_perf',
    operator: 'min',
    isAggr: false,
    render: ({ to }) => (
      <>
        To reduce the chance of thermal throttling, we recommend you go for some
        high grade {to}.
      </>
    ),
  },
  {
    attrName: 'wattage',
    operator: 'max',
    isAggr: true,
    render: ({ from, to, attrValue }) => (
      <>
        Your {from} will require the {to} to be up to {attrValue} Watts.
      </>
    ),
  },
  {
    attrName: 'wifi_included',
    operator: 'is',
    isAggr: false,
    render: ({ from, to }) => (
      <>
        Your {to} already includes {from}. You are doubling up here.
      </>
    ),
  },

  {
    attrName: 'wattage',
    operator: 'min',
    isAggr: false,
    render: ({ from, to, attrValue }) => (
      <>
        Your {from} will require the {to} to be at least {attrValue} Watts.
      </>
    ),
  },
  {
    attrName: 'pcie_slots',
    operator: 'exceed',
    isAggr: true,
    render: ({ option, value }) => (
      <>
        The number of PCIE Slots of you motherboard has been exceeded, please
        select another motherboard or remove/change the component
      </>
    ),
  },
];

export const DEFAULT_TEMPLATES = [
  {
    isAggr: false,
    render: ({ from, to, attrName, attrValue, operator }) => {
      if (
        from.props.option.group_title === 'CPU Cooling System' &&
        to.props.option.group_title === 'CPU' &&
        attrName === 'Chipset'
      ) {
        return (
          <>
            Your {to} requires the {from} to be Intel.
          </>
        );
      }
      if (
        to.props.option.group_title === 'RAM' &&
        from.props.option.group_title === 'Motherboard' &&
        attrName === 'ram_size'
      ) {
        return (
          <>
            The {from} you've selected may not be able to support the amount of {to} you've chosen. Please select a lower amount of RAM or a higher Spec motherboard.
          </>
        );
      }
      if (
        from.props.option.group_title === 'CPU Cooling System' &&
        to.props.option.group_title === 'Chassis fans' &&
        attrName === 'cpu_cooling_extra'
      ) {
        return (
          <>
            Your {from} requires the {to} to be updated.
          </>
        );
      }
      
      return (
        <>
          {from} requires the {to} {attrName} to be {OPERATOR_MAPPING[operator]}{' '}
          {attrValue}.
        </>
      );
    },
  },
];
